import { render, staticRenderFns } from "./TaskIncomeChart.vue?vue&type=template&id=09536a10&scoped=true"
import script from "./TaskIncomeChart.vue?vue&type=script&lang=js"
export * from "./TaskIncomeChart.vue?vue&type=script&lang=js"
import style0 from "./TaskIncomeChart.vue?vue&type=style&index=0&id=09536a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09536a10",
  null
  
)

export default component.exports